import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTimeRangePicker } from '@optios/react-date-time-range-picker'
import moment, { Moment } from 'moment'
import React, { FunctionComponent, useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../../App/Hooks/reduxHooks'
import { IAppointment } from '../../../types'
import { handleAppointmentUpdate } from '../../handleAppointmentUpdate'

import {
  DateTimeRangePickerCancelButton,
  DateTimeRangePickerWrapper,
} from './style'

interface IProps {
  appointmentMoment?: Moment
  setValue: UseFormSetValue<any>
  updateAppointment?: IAppointment
}

export const AppointmentDateRangePicker: FunctionComponent<IProps> = ({
  appointmentMoment,
  setValue,
  updateAppointment,
}) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false)
  const [selectedAndDisplayedDate, setSelectedAndDisplayedDate] =
    useState<Moment>(appointmentMoment || moment)

  const dateChange = (fromDate: Moment) => {
    setSelectedAndDisplayedDate(fromDate)
    setValue('startsAt', fromDate)
    setIsCalendarOpen(false)
    if (typeof updateAppointment !== 'undefined') {
      handleAppointmentUpdate(updateAppointment, fromDate, 'day', dispatch)
    }
  }

  return (
    <>
      <p>{'Code is commented atm.'}</p>
      {/* <LabelInputField*/}
      {/*  fieldLabel={t('DateText')}*/}
      {/*  fieldColor="#005cd9"*/}
      {/*  leadingIcon="calendar-day"*/}
      {/*  initialValue={selectedAndDisplayedDate.format(DATE_LONG_FORMAT)}*/}
      {/*  onFocus={() => setIsCalendarOpen(true)}*/}
      {/*  customWidth="400px"*/}
      {/*  forceChangeValue={selectedAndDisplayedDate.format(DATE_LONG_FORMAT)}*/}
      {/*/ >*/}

      {isCalendarOpen && (
        <DateTimeRangePickerWrapper>
          <DateTimeRangePickerCancelButton
            onClick={() => setIsCalendarOpen(false)}>
            <FontAwesomeIcon icon="cross" />
          </DateTimeRangePickerCancelButton>
          <DateTimeRangePicker onChange={fromDate => dateChange(fromDate)} />
        </DateTimeRangePickerWrapper>
      )}
    </>
  )
}
